import angular from 'angular';

const library = require('@safe-systems/ss-ui-components');

export const {
  applications,
  brandColors,
  contractTypes,
  cookieNames,
  serviceIds,
  services,
  thresholds,
  copy,
} = library.constants;

export default angular.module('app.constants', [])
  .constant('applications', applications)
  .constant('brandColors', brandColors)
  .constant('contractTypes', contractTypes)
  .constant('serviceIds', serviceIds)
  .constant('services', services)
  .constant('thresholds', thresholds)
  .constant('cookieNames', cookieNames)
  .constant('copy', copy)
  .name;

console.log('app.constants created');
